import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/settings/club/")({
  beforeLoad: () => {
    throw redirect({
      to: "/settings/club/coaches",
    })
  },
})
